import { render, staticRenderFns } from "./InputTextElement.vue?vue&type=template&id=35c213f5"
import script from "./InputTextElement.vue?vue&type=script&lang=js"
export * from "./InputTextElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports